export default {
  conclusionCell: {
    textAlign: 'center'
  },
  conclusion: {
    width: '20px'
  },
  received: {
    width: '80px'
  }
}
